import { AdminActivity } from '../models/AdminActivity';
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const getAdminActivitiesFn = httpsCallable(functions, 'getAdminActivities');
const addAdminActivityFn = httpsCallable(functions, 'addAdminActivity');

export class AdminActivityApiService {
  static async getAllActivities(): Promise<AdminActivity[]> {
    try {
      const result = await getAdminActivitiesFn();
      return result.data as AdminActivity[];
    } catch (error) {
      console.error('Failed to fetch admin activities:', error);
      return [];
    }
  }

  static async addActivity(activity: Omit<AdminActivity, 'id' | 'timestamp'>): Promise<AdminActivity | null> {
    try {
      const result = await addAdminActivityFn(activity);
      return result.data as AdminActivity;
    } catch (error) {
      console.error('Failed to add admin activity:', error);
      return null;
    }
  }

  // The clear all functionality is not being used and was part of the old implementation.
  // I will remove it for now to keep the API surface clean.
  // static async clearAllActivities(): Promise<boolean> { ... }
} 